module.exports = __webpack_public_path__ + "assets/img/201.png?d8dcfee1c3f13fc697c203f64217f32f";